/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://5yvwyfvkivgejle547nhxu25ha.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:beca19a9-c00e-4e53-9e68-2c39ca0c5e7a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_ysH9WJ5tQ",
    "aws_user_pools_web_client_id": "ap2um0i4u4ga3utar6kknqt2",
    "oauth": {
        "domain": "openecmr-master.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.openecmr.com/,openecmr://main",
        "redirectSignOut": "https://www.openecmr.com/,openecmr://main",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "openecmr3f9c44cdc7a44ea88aec2d0ef1fb7629-master",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;

